import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class MenuItemTranslatorService {
  constructor(private translateService: TranslateService) {}

  translateItems(i18nScope: string, items: MenuItem[]): MenuItem[] {
    return items.map((item) => this.translateItem(i18nScope, item));
  }

  translateItem(i18nScope: string, item: MenuItem): MenuItem {
    const label = item.label;
    const key = `${i18nScope}.${label}`;
    const value = this.translateService.instant(key);

    if (value !== key) {
      item = {
        ...item,
        label: value
      };
    }

    if (item.items) {
      item = {
        ...item,
        items: this.translateItems(i18nScope, item.items)
      };
    }

    return item;
  }
}
